import { formatDistanceToNow, isValid, parseISO } from 'date-fns';

/** `null` for anything the server sends that does not parse, so the caller omits the line. */
export const orbitRelativeTime = (iso: string): string | null => {
  const date = parseISO(iso);

  return isValid(date) ? formatDistanceToNow(date, { addSuffix: true }) : null;
};

export default orbitRelativeTime;
